import React from "react";
import SummaryDetailsItem from "../../../Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "../../../../../types/SummaryDetailsProps";

const SummaryDetailsDataLeak = ({ caseData }: SummaryDetailsProps) => {
  return (
    <>
      {!!caseData.contractNumber && <SummaryDetailsItem caseData={caseData} fieldPath={"contractNumber"} />}
    </>
  );
};

export default SummaryDetailsDataLeak;
